import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';
import { IEnvironmentConfig } from '../interfaces/config.interface';
import { Constants } from '../constants';
import { IApiResult } from './../interfaces/api-result.interface';
import {
  ILookup,
  ICountry,
  IRegion,
  IVenue,
  IEquipmentPrice,
  IExtendedLookup,
  IFixedPrice,
  IFrequencyBand,
  IBaseStationType,
} from './../interfaces/lookup.interfaces';
import { Observable } from 'rxjs';
import { IPmseEquipmentType, IPmseSpecialEvent } from '../interfaces/pmse.lookup.interfaces';

@Injectable({
  providedIn: 'root',
})
export class LookupsService {
  public config: IEnvironmentConfig;

  constructor(private http: HttpClient, environment: AppConfigService) {
    this.config = environment.config;
  }

  getListByType(type: string): Observable<ILookup[]> {
    const lookupPath = Constants.lookupUrls.typeKey.replace(':type', type);
    return this.http.get(lookupPath).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getAircraftTypes(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.aircraftTypes)
      .pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getBaseStationTypes(): Observable<IBaseStationType[]> {
    return this.http.get(Constants.lookupUrls.baseStationTypes)
      .pipe(map((data: IApiResult<IBaseStationType[]>) => data.value));
  }
  getCountries(): Observable<ICountry[]> {
    return this.http.get(Constants.lookupUrls.countries).pipe(map((data: IApiResult<ICountry[]>) => data.value));
  }
  getCounties(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.counties).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getRegions(): Observable<IRegion[]> {
    return this.http.get(Constants.lookupUrls.regions).pipe(map((data: IApiResult<IRegion[]>) => data.value));
  }
  getVenues(): Observable<IVenue[]> {
    return this.http.get(Constants.lookupUrls.venues).pipe(map((data: IApiResult<IVenue[]>) => data.value));
  }
  getCountiesWithVenues(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.countyWithVenues).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getRadioServicePurposes(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.radioPurposes).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getRadioServiceEquipmentPrices(licenceType: string): Observable<IEquipmentPrice[]> {
    const lookupPath = Constants.lookupUrls.equipmentPrices.replace(':licence-type', licenceType);
    return this.http.get(lookupPath).pipe(map((data: IApiResult<IEquipmentPrice[]>) => data.value));
  }
  getBRBaseStationTypes(): Observable<IExtendedLookup[]> {
    return this.http.get(Constants.lookupUrls.baseStationTypes).pipe(map((data: IApiResult<IExtendedLookup[]>) => data.value));
  }
  getPMSEEquipmentFixedPrice(): Observable<IFixedPrice[]> {
    return this.http.get(Constants.lookupUrls.equipmentFixedPrices).pipe(map((data: IApiResult<IFixedPrice[]>) => data.value));
  }
  getPmseEquipmentTypes(): Observable<IPmseEquipmentType[]> {
    return this.http.get(Constants.lookupUrls.equipmentTypes).pipe(map((data: IApiResult<IPmseEquipmentType[]>) => data.value));
  }
  getPmseSpecialEvents(): Observable<IPmseSpecialEvent[]> {
    return this.http.get(Constants.lookupUrls.specialEvents).pipe(map((data: IApiResult<IPmseSpecialEvent[]>) => data.value));
  }
  getERAutomaticTypes(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.automaticTypes).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getPRSOrganisationTypes(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.prsOrganisationTypes).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getSalutations(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.salutations).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getPrsClasses(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.prsClass).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getPrsSubCategories(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.prsSubCategory).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
  getFrequencyBands(earthStationType: string, stationType: string): Observable<IFrequencyBand[]> {
    return this.http
      .get<IApiResult<IFrequencyBand[]>>(`${Constants.lookupUrls.frequencyBands}/${earthStationType}/${stationType}/frequency-bands`)
      .pipe(map((data) => data.value));
  }
  getBrEquipmentPrices(): Observable<ILookup[]> {
    return this.http.get(Constants.lookupUrls.equipmentBrFixedPrices).pipe(map((data: IApiResult<ILookup[]>) => data.value));
  }
}
